module.exports = __webpack_public_path__ + "img/plan-logo.fe075327.svg";